import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface testItemsProps extends CacheProps {
  hashedLabId: string
  hashedServiceTypeId: string
  hashedCityId: string
}

const labsTestItemsApi = async ({ hashedLabId, hashedCityId, hashedServiceTypeId, ...rest }: testItemsProps) => {
  const res = await fetchApi({
    method: 'POST',
    URL: routes['api.labs.tests'],
    payload: {
      lab_id: hashedLabId,
      service_sub_type_id: hashedServiceTypeId,
      location_id: hashedCityId,
    },
    ...rest,
  });

  return res?.data?.data;
};

export default labsTestItemsApi;
